import styled from "styled-components"
import {Para} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"

const Paragraph = styled(Para)`
  max-width: 200px;
  text-align: center;
  margin-bottom: 30px;
  color: ${greys.medium};
`

export default Paragraph
